import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Popup } from "semantic-ui-react";

/**
 * InformationTag: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Information tag componenent which displays a small
 * info tag with a description upon hover
 *
 * @param {*} props
 */
const InformationTag = props => (
  <Popup
    trigger={
      <small className="ed-file-tag read-only">
        <FormattedMessage id={props.tagIdentifier} />
      </small>
    }
    content={<FormattedMessage id={`${props.tagIdentifier}.description`} />}
  />
);

InformationTag.propTypes = {
  tagIdentifier: PropTypes.string.isRequired
};

export default InformationTag;



// WEBPACK FOOTER //
// ./src/components/ui/InformationTag.js